import createActions from "helpers/actionCreator"
import { createReducer } from "reduxsauce"
import { get } from "lodash"
import { takeLatest } from "redux-saga/effects"
import { computeUpdatedFilters } from "helpers/filters"
import { NORMALIZATION, removeUnsupportedFilters, removeUnsupportedAddedFilters } from "helpers/segments"
import { handleSetSingleDate } from "helpers/date-preferences"
import { Types as LoaderTypes } from "model/data"
import { Types as PortfolioRootTypes } from "modules/portfolio-root/model"

export const { Types, Creators } = createActions("ompnt/modules/analyze-factors", {
  setNormalization: {
    props: ["normalization"],
    track: true,
    trackType: "analyze-factors-normalization-selection",
    trackPayload: ({ normalization }) => ({ normalization }),
  },
  toggleFilters: [],
  setRiskDate: {
    props: ["date"],
    track: true,
    trackType: "analyze-factors-date-selected",
    trackPayload: ({ selectedDate }) => ({ date: get(selectedDate, "adjusted") || get(selectedDate, "selectedDate") }),
  },
  updateFilters: {
    props: ["filter"],
    track: true,
    trackType: "analyze-factors-segment-filters-update",
    trackPayload: ({ filter }) => ({ filter }),
  },
})

const DEFAULT_STATE = {
  normalization: NORMALIZATION.CONTRIBUTION,
  filter: null,
  filtersVisible: false,
}

function handleLoadSuccess(state, action) {
  if (action.resource === "portfolio") {
    return { ...DEFAULT_STATE }
  }

  return state
}

function handleUpdateFilters(state, { filter }) {
  return { ...state, ...computeUpdatedFilters(filter) }
}

function handleSetNormalization(state, { normalization }) {
  return { ...state, normalization }
}

function handleToggleFilters(state) {
  return { ...state, filtersVisible: !state.filtersVisible }
}

const handleSetSelectedBase = (state, { selectedBase }) => {
  const newFilter = removeUnsupportedFilters(state.filter, !!selectedBase, state.normalization)
  const newAddedFilters = removeUnsupportedAddedFilters(state.addedFilters, !!selectedBase, state.normalization)
  return { ...state, filter: newFilter, addedFilters: newAddedFilters }
}

function handleSetRiskDate(state, { date }) {
  return { ...state, riskDate: date }
}

function handlePortfolioSetPeriod(state) {
  return { ...state, selectedDate: null }
}

export default createReducer(DEFAULT_STATE, {
  [LoaderTypes.LOAD_SUCCESS]: handleLoadSuccess,
  [Types.SET_NORMALIZATION]: handleSetNormalization,
  [Types.TOGGLE_FILTERS]: handleToggleFilters,
  [Types.UPDATE_FILTERS]: handleUpdateFilters,
  [Types.SET_RISK_DATE]: handleSetRiskDate,
  [PortfolioRootTypes.SET_SELECTED_BASE]: handleSetSelectedBase,
  [PortfolioRootTypes.SET_PERIOD]: handlePortfolioSetPeriod,
})

export function* saga() {
  yield takeLatest(Types.SET_RISK_DATE, handleSetSingleDate)
}
